import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RefBatDto } from '../model/refbat.model';

@Injectable({
  providedIn: 'root',
})
export class RefbatService {

  constructor(private readonly http: HttpClient) {}

  search(buildingId: number): Observable<RefBatDto[]> {
    const baseUrl = `${environment.apiUrl}/buildings/${buildingId}/refbat`;
    return this.http.get<RefBatDto[]>(baseUrl);
  }
}
